import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import BetCombinationsHeader from "@features/my-bets/desktop/my-bets-page/body/list/item/combinations/BetCombinationsHeader";
import BetCombinationsBody from "@features/my-bets/desktop/my-bets-page/body/list/item/combinations/BetCombinationsBody";
import { useFixBody } from "@state/hooks/shared";

export default observer(function BetCombinations(props: {
	setShowCombinations: (v: boolean) => void;
	showCombinations: boolean;
}) {
	const bet = useContext(MyBetsBetContext);

	const store = useContext(MyBetsStoreContext);

	useFixBody(true, props.showCombinations);

	if (store == null) {
		return null;
	}

	if (!props.showCombinations) {
		return null;
	}

	if (
		!store.betCombinationsMap.has(bet.id) ||
		store.betCombinationsMap.get(bet.id) == null
	) {
		return (
			<div className="popup" data-at="at-BetCombinations--loader">
				<div className="popup__card popup__card--med">
					<BetCombinationsHeader
						setShowCombinations={props.setShowCombinations}
					/>
					<div className="popup__body">
						<div className="loader__spinner loader__spinner--primary" />
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="popup" data-at="at-BetCombinations">
			<div className="popup__card popup__card--med">
				<BetCombinationsHeader
					setShowCombinations={props.setShowCombinations}
				/>
				<BetCombinationsBody />
			</div>
		</div>
	);
});
